

export const consentPropertyType = "site_consent";
export const cookieConsentPropertyType = "CookieConsent";
export const CONST_GENDER_FEMALE = 2;
export const CONST_GENDER_MALE = 1;
export const genderLabel = {
  [CONST_GENDER_MALE]: "Man, looking for a woman",
  [CONST_GENDER_FEMALE]: "Woman, looking for a man",
};
export const genderKey = {
  [CONST_GENDER_MALE]: "man_looking_woman",
  [CONST_GENDER_FEMALE]: "woman_looking_man",
};
export const errorEventsName = {
  empty: "err_lnd_name_noname",
  too_short: "err_lnd_name_shortname",
  invalid_chars: "err_lnd_name_symbolname",
};

export const errorEventsBirthday = {
  M: "err_lnd_age_onlymonth",
  D: "err_lnd_age_onlyday",
  Y: "err_lnd_age_onlyyear",
  MD: "err_lnd_age_onlydaymonth",
  DY: "err_lnd_age_onlydayyear",
  MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
  "Please enter your email": "err_lnd_email_noemail",
  "Please enter a valid email": "err_lnd_email_wrongemail",
};
export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";

export const errorEventsPassword = {
  empty: "err_lnd_password_nopassword",
  too_short: "err_lnd_password_shortpassword",
};

export const IS_VISIBLE_CUSTOM_AUTOCOMPLETE = false;
export const landingId = "20e7c0432c449a0668c5ff8459b9c212"
export const EVENTS_SIGN_IN = [
  "cl_lnd_match_login",
  "cl_lnd_i_am_login",
  "cl_lnd_date_birth_login",
  "cl_lnd_name_login",
  "cl_lnd_email_login",
  "cl_lnd_password_login",
];

export const optionsQ1 = {
  "Not married": "not_married",
  "Divorced": "divorced",
  "Widowed": "widowed",
  "Married": "married",
};

export const optionsQ2 = {
  "Slim": "slim",
  "Athletic": "athletic",
  "Muscular": "muscular",
  "A few extra pounds": "few_extra",
  "Big & Beautiful": "big_beautiful",
};

export const optionsQ3 = {
  "Food": "food",
  "Drink": "drink",
  "Fitness": "fitness",
  "Sports": "sports",
  "Dancing": "dancing",
  "Hockey": "hockey",
  "Boxing": "boxing",
  "Yoga & meditation": "yoga_meditation",
  "Music & concerts": "music_concerts",
  "Photography": "photography",
  "Cars": "cars",
  "Movies": "movies",
  "Cooking": "cooking",
  "Arts": "arts",
  "Nature": "nature",
  "Astrology": "astrology",
  "Shopping": "shopping",
  "Fishing": "fishing",
  "Hunting": "hunting",
  "Reading": "reading",
  "Finance": "finance",
  "News": "news",
  "Traveling": "traveling",
  "Technology": "technology",
  "Other": "other",
};

export const optionsQ4 = {
  "Serious relationship": { value: "serious", index: 9 },
  "Casual chats": { value: "casual", index: 10 },
  "Friendship": { value: "friendship", index: 11 },
  "Open to various connections": { value: "open_to", index: 12 },
};

export const optionsQ5 = {
  "Slim": "slim",
  "Athletic": "athletic",
  "Muscular": "muscular",
  "A few extra pounds": "few_extra",
  "Big & Beautiful": "big_beautiful",
  "No preference": "no_preference",
};

export const footerLinkEvents = {
  "terms-of-use": "terms",
  "privacy-policy": "privacy",
  "cookie-policy": "cookie",
  "refund-policy": "refund",
  "billing-policy": "billing",
  "consent-policy": "consent",
  "mailto": "contact",
};

export const stepFieldMap = {
  5: "marital_status",
  6: "body_type_yourself",
  7: "interests",
  8: "join_reasons",
  10: "body_type"
};